import { LocationId } from '../../../../main/translate/location-id/location-id';

export interface GeneralConfig {
  language: LocationId;
  timezone: string;
}

export interface AttendanceConfig {
  nextTicketTimerDurationMs: number;
  maxCallAttempts: number;
  reconnectDelayMs: number;
}

export interface QueueConfig {
  attendenceQueueOrder: string;
}

export interface AppConfig {
  general: GeneralConfig;
  attendance: AttendanceConfig;
  queue: QueueConfig;
}

export type PartialDeep<T> = {
  [K in keyof T]?: T[K] extends Array<infer U>
    ? Array<PartialDeep<U>>
    : T[K] extends object
      ? PartialDeep<T[K]>
      : T[K];
};

export interface CentralEntityConfigProtocol {
  id?: string;
  name?: string;
  taxId?: string;
  status?: string;
}

export interface CentralSoftwareConfigProtocol {
  entity?: CentralEntityConfigProtocol;
  solution?: {
    software?: Array<{
      id?: string;
      name?: string;
      principalEntity?: string;
      settings?: PartialDeep<AppConfig>;
    }>;
  };
}

export interface IConfigService {
  readonly config: AppConfig;
  init(): Promise<AppConfig>;
  reload(): Promise<AppConfig>;
  applyProtocol(protocol: CentralSoftwareConfigProtocol): Promise<AppConfig>;
  getLanguage(): LocationId;
  getTimezone(): string;
  getPrincipalEntityTaxId(): string | null;
  getCurrentEntityTaxId(): string | null;
  isPrincipalEntityTaxId(taxId?: string | null): boolean;
  isCurrentEntityPrincipal(): boolean;
}

export function createDefaultAppConfig(): AppConfig {
  return {
    general: {
      language: 'pt-BR',
      timezone: 'America/Sao_Paulo',
    },
    attendance: {
      nextTicketTimerDurationMs: 10000,
      maxCallAttempts: 3,
      reconnectDelayMs: 3000,
    },
    queue: {
      attendenceQueueOrder: 'balancedQueue',
    },
  };
}
